import API from "../API/api";
import {initializeLinkListSliderSections} from "../_pages/landing_page/initialize_link_list_slider_sections";
import lazyLoadBackground from '../_modules/lazyload_background';
import Page from "../_pages/page";

const vehicleRecommendedProducts = () => {
    addEventListener('DOMContentLoaded', async function () {
        const vehicleRecommendedProducts = document.querySelector("#vehicle-recommended-products");
        if (vehicleRecommendedProducts) {
            const url = window.location.href;
            const urlObject = new URL(url);
            const path = urlObject.pathname;
            const segments = path.split('/').filter(Boolean);
            const prefix = TYROOLA?.globals?.urlPrefix?.replace(/^\/|\/$/g, '') || '';
            let filteredSegments = segments;
            if (prefix && segments[0] === prefix) {
                filteredSegments = segments.slice(1);
            }

            const parameters = {
                make: filteredSegments[1],
                model: filteredSegments[2],
                dimensions: filteredSegments[4],
                limit: vehicleRecommendedProducts.dataset.limit ?? 10
            };

            const allParametersHaveValue = Object.values(parameters).every(
                (value) => value !== null && value !== undefined && value !== ""
            );

            if (!allParametersHaveValue) {
                let counter = 1;
                let clearIntervalFn3 = setInterval(() => {
                    const isCmsAdsProduct = document.querySelectorAll('#cms-ads-product');
                    const isDrAvailable = document.querySelectorAll('.driverreviews-widget');
                    if ((window.driverreviews && !isCmsAdsProduct.length && isDrAvailable.length) || counter >= 200) {
                        clearInterval(clearIntervalFn3);
                        window.driverreviews && window.driverreviews.refreshWidgets();
                    }
                    counter += 1;
                }, 1000);
                return;
            }

            const vehicleRecommendedTyreSection = document.querySelector("#vehicle-recommended-tyres-section");
            vehicleRecommendedTyreSection.style.display = 'block';
            vehicleRecommendedTyreSection.style.minHeight = '400px';

            let dimensions = parameters.dimensions;
            let width, height, diameter, _;

            if (dimensions.includes('-')) {
                // format "205-15-r16"
                [width, height, diameter] = dimensions.split('-');
                diameter = diameter.replace('r', '');
            } else {
                // format: 7.5r16, 8.5r17.5, 7r15
                [width, diameter] = dimensions.split('r');
                height = 0;
            }

            parameters.width = width;
            parameters.diameter = diameter;
            parameters.height = height;

            console.log(parameters);

            try {
                let response;
                response = await API.GET({
                    apiPath: '/api/v2/vehicle_recommended_products/',
                    dataType: 'html',
                    data: parameters,
                });

                vehicleRecommendedProducts.innerHTML = response;
                const headlineText = document.querySelector('.link-list-sliders__header .link-list-sliders__headline').innerHTML;
                document.querySelector('.link-list-sliders__header .link-list-sliders__headline').innerHTML = `<span>${parameters.limit}</span> ${headlineText}`;

                initializeLinkListSliderSections();
                lazyLoadBackground();

                let counter = 1;
                let clearIntervalFn3 = setInterval(() => {
                    const isCmsAdsProduct = vehicleRecommendedProducts.querySelectorAll('#cms-ads-product');
                    const isDrAvailable = vehicleRecommendedProducts.querySelectorAll('.driverreviews-widget');
                    if ((window.driverreviews && !isCmsAdsProduct.length && isDrAvailable.length) || counter >= 200) {
                        clearInterval(clearIntervalFn3);
                        window.driverreviews && window.driverreviews.refreshWidgets();
                    }
                    counter += 1;
                }, 1000);

                const readMoreLinks = vehicleRecommendedProducts.querySelectorAll('.folded-content-read-more');
                readMoreLinks.forEach(link => {
                    link.addEventListener('click', (event) => {
                        event.preventDefault();
                        link.style.display = 'none';

                        const foldedContentElement = link.previousElementSibling;
                        if (foldedContentElement && foldedContentElement.classList.contains('folded-content')) {
                            foldedContentElement.classList.remove('folded-content');
                        }
                    });
                });

                Page.attachEuLabelsLightboxOnClick();

                return Promise.resolve(response);
            } catch (error) {
                console.log('ERROR: ', error);
                return Promise.reject(error);
            }
        }
    });
};

export default vehicleRecommendedProducts;
